import {TOKENS} from '../../tokens'

export const toast = {
  dark: {
    defaultActionText: TOKENS.dark.contrast_600,
    successBg: TOKENS.dark.positive_25,
    successBorder: TOKENS.dark.positive_100,
    successText: TOKENS.dark.positive_700,
    successActionText: TOKENS.dark.positive_900,
    successActionTextHover: TOKENS.dark.positive_975,
    successActionBgHover: TOKENS.dark.positive_50,
    errorBg: TOKENS.dark.negative_25,
    errorBorder: TOKENS.dark.negative_100,
    errorText: TOKENS.dark.negative_900,
    errorActionText: TOKENS.dark.negative_900,
    errorActionTextHover: TOKENS.dark.negative_975,
    errorActionBgHover: TOKENS.dark.negative_50,
  },
  light: {
    defaultActionText: TOKENS.light.contrast_600,
    successBg: TOKENS.light.positive_25,
    successBorder: TOKENS.light.positive_300,
    successText: TOKENS.light.positive_600,
    successActionText: TOKENS.light.positive_800,
    successActionTextHover: TOKENS.light.positive_975,
    successActionBgHover: TOKENS.light.positive_50,
    errorBg: TOKENS.light.negative_25,
    errorBorder: TOKENS.light.negative_200,
    errorText: TOKENS.light.negative_700,
    errorActionText: TOKENS.light.negative_700,
    errorActionTextHover: TOKENS.light.negative_975,
    errorActionBgHover: TOKENS.light.negative_50,
  },
} as const
